import { ScreenResizeAction } from 'actions/general';
import { connect, ConnectedProps } from 'react-redux';

const mapDispatchToProps = { ScreenResizeAction };

export const connector = connect(null, mapDispatchToProps);

export type Props = ConnectedProps<typeof connector>;
